import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { uiStateSaga } from './saga';
import { UiStateState } from './types';

export const initialState: UiStateState = {
  isSidebarOpen: true,
  currentSection: 'dashboard',
};

const slice = createSlice({
  name: 'uiState',
  initialState,
  reducers: {
    setIsSidebarOpen(state, action:PayloadAction<boolean>) {
      state.isSidebarOpen = action.payload;
    },
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setCurrentSection(state, action: PayloadAction<string>) {
      state.currentSection = action.payload;
    },
  },
});

export const { actions: uiStateActions, reducer } = slice;

export const useUiStateSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: uiStateSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useUiStateSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
